/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const IconSmall2 = ({ className }) => {
  return (
    <svg
      className={`icon-small-2 ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M15.9205 5.06089C15.5784 4.72456 15.1722 4.45775 14.7252 4.27572C14.2782 4.09369 13.799 4 13.3151 4C12.8312 4 12.3521 4.09369 11.905 4.27572C11.458 4.45775 11.0518 4.72456 10.7098 5.06089L9.99982 5.75857L9.28988 5.06089C8.5989 4.38184 7.66172 4.00035 6.68453 4.00035C5.70733 4.00035 4.77016 4.38184 4.07917 5.06089C3.38819 5.73994 3 6.66092 3 7.62125C3 8.58157 3.38819 9.50255 4.07917 10.1816L4.78911 10.8793L9.2989 15.3112C9.68797 15.6935 10.3117 15.6935 10.7007 15.3112L15.2105 10.8793L15.9205 10.1816C16.2627 9.84543 16.5342 9.44628 16.7194 9.00697C16.9047 8.56765 17 8.09678 17 7.62125C17 7.14571 16.9047 6.67484 16.7194 6.23552C16.5342 5.79621 16.2627 5.39706 15.9205 5.06089Z"
        fill="#FD0658"
      />
    </svg>
  );
};
